import { BlogPost } from './types';

// English blog posts
import removeWatermarksWordPagesRaw from './posts/remove-watermarks-word-pages.md?raw';
import aiTextWatermarksExplainedRaw from './posts/ai-text-watermarks-explained.md?raw';
import howToCheckChatGPTWatermarkRaw from './posts/how-to-check-chatgpt-watermark.md?raw';
import invisibleCharactersChatGPTRaw from './posts/invisible-characters-chatgpt.md?raw';
import aiWatermarkEthicsRaw from './posts/ai-watermark-ethics.md?raw';
import removeChatGPTWatermarkWordRaw from './posts/remove-chatgpt-watermark-word.md?raw';
import chatgptTextWordDocsRisksRaw from './posts/chatgpt-text-word-docs-risks.md?raw';
import aiWatermarksAcademicIntegrityRaw from './posts/ai-watermarks-academic-integrity.md?raw';
import invisibleChatgptWatermarksRaw from './posts/invisible-chatgpt-watermarks.md?raw';
import whyAiDetectorSayingWritingIsAiRaw from './posts/why-ai-detector-saying-writing-is-ai.md?raw';
import isAiContentBadForSeoRaw from './posts/is-ai-content-bad-for-seo.md?raw';
import canRecruitersDetectChatgptRaw from './posts/can-recruiters-tell-if-you-used-chatgpt.md?raw';
import howToRemoveGeminiImageWatermarksRaw from './posts/how-to-remove-gemini-image-watermarks.md?raw';
import bestToolsRemoveWatermarksImagesRaw from './posts/best-tools-remove-watermarks-images.md?raw';
import aiResumeAtsWatermarksGuideRaw from './posts/ai-resume-ats-watermarks-guide.md?raw';
import whereToCheckAiWritingRaw from './posts/where-to-check-ai-writing.md?raw';
import soraAiWatermarkRaw from './posts/sora-ai-watermark.md?raw';
import doesChatgptWatermarkTextRaw from './posts/does-chatgpt-watermark-text.md?raw';
import commonAiWordsRaw from './posts/common-ai-words-to-avoid-complete-list.md?raw';
import chatgptEmDashesRaw from './posts/chatgpt-em-dashes-why-ai-uses-them-how-to-remove.md?raw';
import howToSpotAiTextJobApplicationsRaw from './posts/how-to-spot-ai-generated-text-job-applications.md?raw';
import whyAllAiWritingSoundsTheSameRaw from './posts/why-all-ai-writing-sounds-the-same.md?raw';
import doesClaudeWatermarkTextRaw from './posts/does-claude-watermark-text.md?raw';

// German blog posts
import removeWatermarksWordPagesDeRaw from './posts/de/remove-watermarks-word-pages.md?raw';
import aiTextWatermarksExplainedDeRaw from './posts/de/ai-text-watermarks-explained.md?raw';
import howToCheckChatGPTWatermarkDeRaw from './posts/de/how-to-check-chatgpt-watermark.md?raw';
import invisibleCharactersChatGPTDeRaw from './posts/de/invisible-characters-chatgpt.md?raw';
import aiWatermarkEthicsDeRaw from './posts/de/ai-watermark-ethics.md?raw';
import removeChatGPTWatermarkWordDeRaw from './posts/de/remove-chatgpt-watermark-word.md?raw';
import chatgptTextWordDocsRisksDeRaw from './posts/de/chatgpt-text-word-docs-risks.md?raw';
import aiWatermarksAcademicIntegrityDeRaw from './posts/de/ai-watermarks-academic-integrity.md?raw';
import invisibleChatgptWatermarksDeRaw from './posts/de/invisible-chatgpt-watermarks.md?raw';
import whyAiDetectorSayingWritingIsAiDeRaw from './posts/de/why-ai-detector-saying-writing-is-ai.md?raw';
import isAiContentBadForSeoDeRaw from './posts/de/is-ai-content-bad-for-seo.md?raw';
import canRecruitersDetectChatgptDeRaw from './posts/de/can-recruiters-tell-if-you-used-chatgpt.md?raw';
import howToRemoveGeminiImageWatermarksDeRaw from './posts/de/how-to-remove-gemini-image-watermarks.md?raw';
import bestToolsRemoveWatermarksImagesDeRaw from './posts/de/best-tools-remove-watermarks-images.md?raw';
import aiResumeAtsWatermarksGuideDeRaw from './posts/de/ai-resume-ats-watermarks-guide.md?raw';
import whereToCheckAiWritingDeRaw from './posts/de/where-to-check-ai-writing.md?raw';
import soraAiWatermarkDeRaw from './posts/de/sora-ai-watermark.md?raw';
import doesChatgptWatermarkTextDeRaw from './posts/de/does-chatgpt-watermark-text.md?raw';
import commonAiWordsDeRaw from './posts/de/common-ai-words-to-avoid-complete-list.md?raw';
import chatgptEmDashesDeRaw from './posts/de/chatgpt-em-dashes-why-ai-uses-them-how-to-remove.md?raw';
import howToSpotAiTextJobApplicationsDeRaw from './posts/de/how-to-spot-ai-generated-text-job-applications.md?raw';
import whyAllAiWritingSoundsTheSameDeRaw from './posts/de/why-all-ai-writing-sounds-the-same.md?raw';
import doesClaudeWatermarkTextDeRaw from './posts/de/does-claude-watermark-text.md?raw';

// Portuguese blog posts
import removeWatermarksWordPagesPtRaw from './posts/pt-BR/remove-watermarks-word-pages.md?raw';
import aiTextWatermarksExplainedPtRaw from './posts/pt-BR/ai-text-watermarks-explained.md?raw';
import howToCheckChatGPTWatermarkPtRaw from './posts/pt-BR/how-to-check-chatgpt-watermark.md?raw';
import invisibleCharactersChatGPTPtRaw from './posts/pt-BR/invisible-characters-chatgpt.md?raw';
import aiWatermarkEthicsPtRaw from './posts/pt-BR/ai-watermark-ethics.md?raw';
import removeChatGPTWatermarkWordPtRaw from './posts/pt-BR/remove-chatgpt-watermark-word.md?raw';
import chatgptTextWordDocsRisksPtRaw from './posts/pt-BR/chatgpt-text-word-docs-risks.md?raw';
import aiWatermarksAcademicIntegrityPtRaw from './posts/pt-BR/ai-watermarks-academic-integrity.md?raw';
import invisibleChatgptWatermarksPtRaw from './posts/pt-BR/invisible-chatgpt-watermarks.md?raw';
import whyAiDetectorSayingWritingIsAiPtRaw from './posts/pt-BR/why-ai-detector-saying-writing-is-ai.md?raw';
import isAiContentBadForSeoPtRaw from './posts/pt-BR/is-ai-content-bad-for-seo.md?raw';
import canRecruitersDetectChatgptPtRaw from './posts/pt-BR/can-recruiters-tell-if-you-used-chatgpt.md?raw';
import howToRemoveGeminiImageWatermarksPtRaw from './posts/pt-BR/how-to-remove-gemini-image-watermarks.md?raw';
import bestToolsRemoveWatermarksImagesPtRaw from './posts/pt-BR/best-tools-remove-watermarks-images.md?raw';
import aiResumeAtsWatermarksGuidePtRaw from './posts/pt-BR/ai-resume-ats-watermarks-guide.md?raw';
import whereToCheckAiWritingPtRaw from './posts/pt-BR/where-to-check-ai-writing.md?raw';
import soraAiWatermarkPtRaw from './posts/pt-BR/sora-ai-watermark.md?raw';
import doesChatgptWatermarkTextPtRaw from './posts/pt-BR/does-chatgpt-watermark-text.md?raw';
import commonAiWordsPtRaw from './posts/pt-BR/common-ai-words-to-avoid-complete-list.md?raw';
import chatgptEmDashesPtRaw from './posts/pt-BR/chatgpt-em-dashes-why-ai-uses-them-how-to-remove.md?raw';
import howToSpotAiTextJobApplicationsPtRaw from './posts/pt-BR/how-to-spot-ai-generated-text-job-applications.md?raw';
import whyAllAiWritingSoundsTheSamePtRaw from './posts/pt-BR/why-all-ai-writing-sounds-the-same.md?raw';
import doesClaudeWatermarkTextPtRaw from './posts/pt-BR/does-claude-watermark-text.md?raw';

// Malay blog posts
import removeWatermarksWordPagesMsRaw from './posts/ms-MY/remove-watermarks-word-pages.md?raw';
import aiTextWatermarksExplainedMsRaw from './posts/ms-MY/ai-text-watermarks-explained.md?raw';
import howToCheckChatGPTWatermarkMsRaw from './posts/ms-MY/how-to-check-chatgpt-watermark.md?raw';
import invisibleCharactersChatGPTMsRaw from './posts/ms-MY/invisible-characters-chatgpt.md?raw';
import aiWatermarkEthicsMsRaw from './posts/ms-MY/ai-watermark-ethics.md?raw';
import removeChatGPTWatermarkWordMsRaw from './posts/ms-MY/remove-chatgpt-watermark-word.md?raw';
import chatgptTextWordDocsRisksMsRaw from './posts/ms-MY/chatgpt-text-word-docs-risks.md?raw';
import aiWatermarksAcademicIntegrityMsRaw from './posts/ms-MY/ai-watermarks-academic-integrity.md?raw';
import invisibleChatgptWatermarksMsRaw from './posts/ms-MY/invisible-chatgpt-watermarks.md?raw';
import whyAiDetectorSayingWritingIsAiMsRaw from './posts/ms-MY/why-ai-detector-saying-writing-is-ai.md?raw';
import isAiContentBadForSeoMsRaw from './posts/ms-MY/is-ai-content-bad-for-seo.md?raw';
import canRecruitersDetectChatgptMsRaw from './posts/ms-MY/can-recruiters-tell-if-you-used-chatgpt.md?raw';
import howToRemoveGeminiImageWatermarksMsRaw from './posts/ms-MY/how-to-remove-gemini-image-watermarks.md?raw';
import bestToolsRemoveWatermarksImagesMsRaw from './posts/ms-MY/best-tools-remove-watermarks-images.md?raw';
import aiResumeAtsWatermarksGuideMsRaw from './posts/ms-MY/ai-resume-ats-watermarks-guide.md?raw';
import whereToCheckAiWritingMsRaw from './posts/ms-MY/where-to-check-ai-writing.md?raw';
import soraAiWatermarkMsRaw from './posts/ms-MY/sora-ai-watermark.md?raw';
import doesChatgptWatermarkTextMsRaw from './posts/ms-MY/does-chatgpt-watermark-text.md?raw';
import commonAiWordsMsRaw from './posts/ms-MY/common-ai-words-to-avoid-complete-list.md?raw';
import chatgptEmDashesMsRaw from './posts/ms-MY/chatgpt-em-dashes-why-ai-uses-them-how-to-remove.md?raw';
import howToSpotAiTextJobApplicationsMsRaw from './posts/ms-MY/how-to-spot-ai-generated-text-job-applications.md?raw';
import whyAllAiWritingSoundsTheSameMsRaw from './posts/ms-MY/why-all-ai-writing-sounds-the-same.md?raw';
import doesClaudeWatermarkTextMsRaw from './posts/ms-MY/does-claude-watermark-text.md?raw';

// Spanish blog posts
import removeWatermarksWordPagesEsRaw from './posts/es/remove-watermarks-word-pages.md?raw';
import aiTextWatermarksExplainedEsRaw from './posts/es/ai-text-watermarks-explained.md?raw';
import howToCheckChatGPTWatermarkEsRaw from './posts/es/how-to-check-chatgpt-watermark.md?raw';
import invisibleCharactersChatGPTEsRaw from './posts/es/invisible-characters-chatgpt.md?raw';
import aiWatermarkEthicsEsRaw from './posts/es/ai-watermark-ethics.md?raw';
import removeChatGPTWatermarkWordEsRaw from './posts/es/remove-chatgpt-watermark-word.md?raw';
import chatgptTextWordDocsRisksEsRaw from './posts/es/chatgpt-text-word-docs-risks.md?raw';
import aiWatermarksAcademicIntegrityEsRaw from './posts/es/ai-watermarks-academic-integrity.md?raw';
import invisibleChatgptWatermarksEsRaw from './posts/es/invisible-chatgpt-watermarks.md?raw';
import whyAiDetectorSayingWritingIsAiEsRaw from './posts/es/why-ai-detector-saying-writing-is-ai.md?raw';
import isAiContentBadForSeoEsRaw from './posts/es/is-ai-content-bad-for-seo.md?raw';
import canRecruitersDetectChatgptEsRaw from './posts/es/can-recruiters-tell-if-you-used-chatgpt.md?raw';
import howToRemoveGeminiImageWatermarksEsRaw from './posts/es/how-to-remove-gemini-image-watermarks.md?raw';
import bestToolsRemoveWatermarksImagesEsRaw from './posts/es/best-tools-remove-watermarks-images.md?raw';
import aiResumeAtsWatermarksGuideEsRaw from './posts/es/ai-resume-ats-watermarks-guide.md?raw';
import whereToCheckAiWritingEsRaw from './posts/es/where-to-check-ai-writing.md?raw';
import soraAiWatermarkEsRaw from './posts/es/sora-ai-watermark.md?raw';
import doesChatgptWatermarkTextEsRaw from './posts/es/does-chatgpt-watermark-text.md?raw';
import commonAiWordsEsRaw from './posts/es/common-ai-words-to-avoid-complete-list.md?raw';
import chatgptEmDashesEsRaw from './posts/es/chatgpt-em-dashes-why-ai-uses-them-how-to-remove.md?raw';
import howToSpotAiTextJobApplicationsEsRaw from './posts/es/how-to-spot-ai-generated-text-job-applications.md?raw';
import whyAllAiWritingSoundsTheSameEsRaw from './posts/es/why-all-ai-writing-sounds-the-same.md?raw';
import doesClaudeWatermarkTextEsRaw from './posts/es/does-claude-watermark-text.md?raw';

// French blog posts
import removeWatermarksWordPagesFrRaw from './posts/fr/remove-watermarks-word-pages.md?raw';
import aiTextWatermarksExplainedFrRaw from './posts/fr/ai-text-watermarks-explained.md?raw';
import howToCheckChatGPTWatermarkFrRaw from './posts/fr/how-to-check-chatgpt-watermark.md?raw';
import invisibleCharactersChatGPTFrRaw from './posts/fr/invisible-characters-chatgpt.md?raw';
import aiWatermarkEthicsFrRaw from './posts/fr/ai-watermark-ethics.md?raw';
import removeChatGPTWatermarkWordFrRaw from './posts/fr/remove-chatgpt-watermark-word.md?raw';
import chatgptTextWordDocsRisksFrRaw from './posts/fr/chatgpt-text-word-docs-risks.md?raw';
import aiWatermarksAcademicIntegrityFrRaw from './posts/fr/ai-watermarks-academic-integrity.md?raw';
import invisibleChatgptWatermarksFrRaw from './posts/fr/invisible-chatgpt-watermarks.md?raw';
import whyAiDetectorSayingWritingIsAiFrRaw from './posts/fr/why-ai-detector-saying-writing-is-ai.md?raw';
import isAiContentBadForSeoFrRaw from './posts/fr/is-ai-content-bad-for-seo.md?raw';
import canRecruitersDetectChatgptFrRaw from './posts/fr/can-recruiters-tell-if-you-used-chatgpt.md?raw';
import canTurnitinDetectChatgptFrRaw from './posts/fr/can-turnitin-detect-chatgpt.md?raw';
import howToRemoveGeminiImageWatermarksFrRaw from './posts/fr/how-to-remove-gemini-image-watermarks.md?raw';
import bestToolsRemoveWatermarksImagesFrRaw from './posts/fr/best-tools-remove-watermarks-images.md?raw';
import aiResumeAtsWatermarksGuideFrRaw from './posts/fr/ai-resume-ats-watermarks-guide.md?raw';
import whereToCheckAiWritingFrRaw from './posts/fr/where-to-check-ai-writing.md?raw';
import soraAiWatermarkFrRaw from './posts/fr/sora-ai-watermark.md?raw';
import doesChatgptWatermarkTextFrRaw from './posts/fr/does-chatgpt-watermark-text.md?raw';
import commonAiWordsFrRaw from './posts/fr/common-ai-words-to-avoid-complete-list.md?raw';
import chatgptEmDashesFrRaw from './posts/fr/chatgpt-em-dashes-why-ai-uses-them-how-to-remove.md?raw';
import howToSpotAiTextJobApplicationsFrRaw from './posts/fr/how-to-spot-ai-generated-text-job-applications.md?raw';
import whyAllAiWritingSoundsTheSameFrRaw from './posts/fr/why-all-ai-writing-sounds-the-same.md?raw';
import doesClaudeWatermarkTextFrRaw from './posts/fr/does-claude-watermark-text.md?raw';

// Japanese blog posts
import removeWatermarksWordPagesJaRaw from './posts/ja/remove-watermarks-word-pages.md?raw';
import aiTextWatermarksExplainedJaRaw from './posts/ja/ai-text-watermarks-explained.md?raw';
import howToCheckChatGPTWatermarkJaRaw from './posts/ja/how-to-check-chatgpt-watermark.md?raw';
import invisibleCharactersChatGPTJaRaw from './posts/ja/invisible-characters-chatgpt.md?raw';
import aiWatermarkEthicsJaRaw from './posts/ja/ai-watermark-ethics.md?raw';
import removeChatGPTWatermarkWordJaRaw from './posts/ja/remove-chatgpt-watermark-word.md?raw';
import chatgptTextWordDocsRisksJaRaw from './posts/ja/chatgpt-text-word-docs-risks.md?raw';
import aiWatermarksAcademicIntegrityJaRaw from './posts/ja/ai-watermarks-academic-integrity.md?raw';
import invisibleChatgptWatermarksJaRaw from './posts/ja/invisible-chatgpt-watermarks.md?raw';
import whyAiDetectorSayingWritingIsAiJaRaw from './posts/ja/why-ai-detector-saying-writing-is-ai.md?raw';
import isAiContentBadForSeoJaRaw from './posts/ja/is-ai-content-bad-for-seo.md?raw';
import canRecruitersDetectChatgptJaRaw from './posts/ja/can-recruiters-tell-if-you-used-chatgpt.md?raw';
import canTurnitinDetectChatgptJaRaw from './posts/ja/can-turnitin-detect-chatgpt.md?raw';
import howToRemoveGeminiImageWatermarksJaRaw from './posts/ja/how-to-remove-gemini-image-watermarks.md?raw';
import bestToolsRemoveWatermarksImagesJaRaw from './posts/ja/best-tools-remove-watermarks-images.md?raw';
import aiResumeAtsWatermarksGuideJaRaw from './posts/ja/ai-resume-ats-watermarks-guide.md?raw';
import whereToCheckAiWritingJaRaw from './posts/ja/where-to-check-ai-writing.md?raw';
import soraAiWatermarkJaRaw from './posts/ja/sora-ai-watermark.md?raw';
import doesChatgptWatermarkTextJaRaw from './posts/ja/does-chatgpt-watermark-text.md?raw';
import commonAiWordsJaRaw from './posts/ja/common-ai-words-to-avoid-complete-list.md?raw';
import chatgptEmDashesJaRaw from './posts/ja/chatgpt-em-dashes-why-ai-uses-them-how-to-remove.md?raw';
import howToSpotAiTextJobApplicationsJaRaw from './posts/ja/how-to-spot-ai-generated-text-job-applications.md?raw';
import whyAllAiWritingSoundsTheSameJaRaw from './posts/ja/why-all-ai-writing-sounds-the-same.md?raw';
import doesClaudeWatermarkTextJaRaw from './posts/ja/does-claude-watermark-text.md?raw';

// Indonesian blog posts
import removeWatermarksWordPagesIdRaw from './posts/id/remove-watermarks-word-pages.md?raw';
import aiTextWatermarksExplainedIdRaw from './posts/id/ai-text-watermarks-explained.md?raw';
import howToCheckChatGPTWatermarkIdRaw from './posts/id/how-to-check-chatgpt-watermark.md?raw';
import invisibleCharactersChatGPTIdRaw from './posts/id/invisible-characters-chatgpt.md?raw';
import aiWatermarkEthicsIdRaw from './posts/id/ai-watermark-ethics.md?raw';
import removeChatGPTWatermarkWordIdRaw from './posts/id/remove-chatgpt-watermark-word.md?raw';
import chatgptTextWordDocsRisksIdRaw from './posts/id/chatgpt-text-word-docs-risks.md?raw';
import aiWatermarksAcademicIntegrityIdRaw from './posts/id/ai-watermarks-academic-integrity.md?raw';
import invisibleChatgptWatermarksIdRaw from './posts/id/invisible-chatgpt-watermarks.md?raw';
import whyAiDetectorSayingWritingIsAiIdRaw from './posts/id/why-ai-detector-saying-writing-is-ai.md?raw';
import isAiContentBadForSeoIdRaw from './posts/id/is-ai-content-bad-for-seo.md?raw';
import canRecruitersDetectChatgptIdRaw from './posts/id/can-recruiters-tell-if-you-used-chatgpt.md?raw';
import canTurnitinDetectChatgptIdRaw from './posts/id/can-turnitin-detect-chatgpt.md?raw';
import howToRemoveGeminiImageWatermarksIdRaw from './posts/id/how-to-remove-gemini-image-watermarks.md?raw';
import bestToolsRemoveWatermarksImagesIdRaw from './posts/id/best-tools-remove-watermarks-images.md?raw';
import aiResumeAtsWatermarksGuideIdRaw from './posts/id/ai-resume-ats-watermarks-guide.md?raw';
import whereToCheckAiWritingIdRaw from './posts/id/where-to-check-ai-writing.md?raw';
import soraAiWatermarkIdRaw from './posts/id/sora-ai-watermark.md?raw';
import doesChatgptWatermarkTextIdRaw from './posts/id/does-chatgpt-watermark-text.md?raw';
import commonAiWordsIdRaw from './posts/id/common-ai-words-to-avoid-complete-list.md?raw';
import chatgptEmDashesIdRaw from './posts/id/chatgpt-em-dashes-why-ai-uses-them-how-to-remove.md?raw';
import howToSpotAiTextJobApplicationsIdRaw from './posts/id/how-to-spot-ai-generated-text-job-applications.md?raw';
import whyAllAiWritingSoundsTheSameIdRaw from './posts/id/why-all-ai-writing-sounds-the-same.md?raw';
import doesClaudeWatermarkTextIdRaw from './posts/id/does-claude-watermark-text.md?raw';

// Helper function to parse frontmatter manually (browser-compatible)
function parseFrontmatter(markdown: string): { data: Record<string, any>; content: string } {
  const frontmatterRegex = /^---\n([\s\S]*?)\n---\n([\s\S]*)$/;
  const match = markdown.match(frontmatterRegex);

  if (!match) {
    return { data: {}, content: markdown };
  }

  const frontmatterText = match[1];
  const content = match[2];

  // Parse YAML-like frontmatter
  const data: Record<string, any> = {};
  const lines = frontmatterText.split('\n');

  for (const line of lines) {
    const colonIndex = line.indexOf(':');
    if (colonIndex === -1) continue;

    const key = line.substring(0, colonIndex).trim();
    let value: any = line.substring(colonIndex + 1).trim();

    // Remove quotes
    if ((value.startsWith('"') && value.endsWith('"')) ||
        (value.startsWith("'") && value.endsWith("'"))) {
      value = value.slice(1, -1);
    }

    // Parse arrays (keywords, tags) - handle both [item1, item2] and "item1, item2" formats
    if (key === 'keywords' || key === 'tags') {
      if (value.startsWith('[') && value.endsWith(']')) {
        // Array format: [item1, item2]
        value = value
          .slice(1, -1)
          .split(',')
          .map((item: string) => item.trim().replace(/^["']|["']$/g, ''));
      } else if (typeof value === 'string' && value.includes(',')) {
        // Comma-separated string format: "item1, item2"
        value = value.split(',').map((item: string) => item.trim());
      } else if (typeof value === 'string') {
        // Single keyword/tag as string
        value = [value];
      }
    }

    data[key] = value;
  }

  return { data, content };
}

// Define all blog posts by locale
const blogPostsData: Record<string, Array<{ slug: string; raw: string }>> = {
  en: [
    { slug: 'invisible-chatgpt-watermarks', raw: invisibleChatgptWatermarksRaw },
    { slug: 'ai-watermarks-academic-integrity', raw: aiWatermarksAcademicIntegrityRaw },
    { slug: 'chatgpt-text-word-docs-risks', raw: chatgptTextWordDocsRisksRaw },
    { slug: 'remove-chatgpt-watermark-word', raw: removeChatGPTWatermarkWordRaw },
    { slug: 'ai-watermark-ethics', raw: aiWatermarkEthicsRaw },
    { slug: 'invisible-characters-chatgpt', raw: invisibleCharactersChatGPTRaw },
    { slug: 'remove-watermarks-word-pages', raw: removeWatermarksWordPagesRaw },
    { slug: 'ai-text-watermarks-explained', raw: aiTextWatermarksExplainedRaw },
    { slug: 'how-to-check-chatgpt-watermark', raw: howToCheckChatGPTWatermarkRaw },
    { slug: 'why-ai-detector-saying-writing-is-ai', raw: whyAiDetectorSayingWritingIsAiRaw },
    { slug: 'is-ai-content-bad-for-seo', raw: isAiContentBadForSeoRaw },
    { slug: 'can-recruiters-tell-if-you-used-chatgpt', raw: canRecruitersDetectChatgptRaw },
    { slug: 'how-to-remove-gemini-image-watermarks', raw: howToRemoveGeminiImageWatermarksRaw },
    { slug: 'best-tools-remove-watermarks-images', raw: bestToolsRemoveWatermarksImagesRaw },
    { slug: 'ai-resume-ats-watermarks-guide', raw: aiResumeAtsWatermarksGuideRaw },
    { slug: 'where-to-check-ai-writing', raw: whereToCheckAiWritingRaw },
    { slug: 'sora-ai-watermark', raw: soraAiWatermarkRaw },
    { slug: 'does-chatgpt-watermark-text', raw: doesChatgptWatermarkTextRaw },
    { slug: 'common-ai-words-to-avoid-complete-list', raw: commonAiWordsRaw },
    { slug: 'chatgpt-em-dashes-why-ai-uses-them-how-to-remove', raw: chatgptEmDashesRaw },
    { slug: 'how-to-spot-ai-generated-text-job-applications', raw: howToSpotAiTextJobApplicationsRaw },
    { slug: 'why-all-ai-writing-sounds-the-same', raw: whyAllAiWritingSoundsTheSameRaw },
    { slug: 'does-claude-watermark-text', raw: doesClaudeWatermarkTextRaw },
  ],
  de: [
    { slug: 'invisible-chatgpt-watermarks', raw: invisibleChatgptWatermarksDeRaw },
    { slug: 'ai-watermarks-academic-integrity', raw: aiWatermarksAcademicIntegrityDeRaw },
    { slug: 'chatgpt-text-word-docs-risks', raw: chatgptTextWordDocsRisksDeRaw },
    { slug: 'remove-chatgpt-watermark-word', raw: removeChatGPTWatermarkWordDeRaw },
    { slug: 'ai-watermark-ethics', raw: aiWatermarkEthicsDeRaw },
    { slug: 'invisible-characters-chatgpt', raw: invisibleCharactersChatGPTDeRaw },
    { slug: 'remove-watermarks-word-pages', raw: removeWatermarksWordPagesDeRaw },
    { slug: 'ai-text-watermarks-explained', raw: aiTextWatermarksExplainedDeRaw },
    { slug: 'how-to-check-chatgpt-watermark', raw: howToCheckChatGPTWatermarkDeRaw },
    { slug: 'why-ai-detector-saying-writing-is-ai', raw: whyAiDetectorSayingWritingIsAiDeRaw },
    { slug: 'is-ai-content-bad-for-seo', raw: isAiContentBadForSeoDeRaw },
    { slug: 'can-recruiters-tell-if-you-used-chatgpt', raw: canRecruitersDetectChatgptDeRaw },
    { slug: 'how-to-remove-gemini-image-watermarks', raw: howToRemoveGeminiImageWatermarksDeRaw },
    { slug: 'best-tools-remove-watermarks-images', raw: bestToolsRemoveWatermarksImagesDeRaw },
    { slug: 'ai-resume-ats-watermarks-guide', raw: aiResumeAtsWatermarksGuideDeRaw },
    { slug: 'where-to-check-ai-writing', raw: whereToCheckAiWritingDeRaw },
    { slug: 'sora-ai-watermark', raw: soraAiWatermarkDeRaw },
    { slug: 'does-chatgpt-watermark-text', raw: doesChatgptWatermarkTextDeRaw },
    { slug: 'common-ai-words-to-avoid-complete-list', raw: commonAiWordsDeRaw },
    { slug: 'chatgpt-em-dashes-why-ai-uses-them-how-to-remove', raw: chatgptEmDashesDeRaw },
    { slug: 'how-to-spot-ai-generated-text-job-applications', raw: howToSpotAiTextJobApplicationsDeRaw },
    { slug: 'why-all-ai-writing-sounds-the-same', raw: whyAllAiWritingSoundsTheSameDeRaw },
    { slug: 'does-claude-watermark-text', raw: doesClaudeWatermarkTextDeRaw },
  ],
  'pt-BR': [
    { slug: 'invisible-chatgpt-watermarks', raw: invisibleChatgptWatermarksPtRaw },
    { slug: 'ai-watermarks-academic-integrity', raw: aiWatermarksAcademicIntegrityPtRaw },
    { slug: 'chatgpt-text-word-docs-risks', raw: chatgptTextWordDocsRisksPtRaw },
    { slug: 'remove-chatgpt-watermark-word', raw: removeChatGPTWatermarkWordPtRaw },
    { slug: 'ai-watermark-ethics', raw: aiWatermarkEthicsPtRaw },
    { slug: 'invisible-characters-chatgpt', raw: invisibleCharactersChatGPTPtRaw },
    { slug: 'remove-watermarks-word-pages', raw: removeWatermarksWordPagesPtRaw },
    { slug: 'ai-text-watermarks-explained', raw: aiTextWatermarksExplainedPtRaw },
    { slug: 'how-to-check-chatgpt-watermark', raw: howToCheckChatGPTWatermarkPtRaw },
    { slug: 'why-ai-detector-saying-writing-is-ai', raw: whyAiDetectorSayingWritingIsAiPtRaw },
    { slug: 'is-ai-content-bad-for-seo', raw: isAiContentBadForSeoPtRaw },
    { slug: 'can-recruiters-tell-if-you-used-chatgpt', raw: canRecruitersDetectChatgptPtRaw },
    { slug: 'how-to-remove-gemini-image-watermarks', raw: howToRemoveGeminiImageWatermarksPtRaw },
    { slug: 'best-tools-remove-watermarks-images', raw: bestToolsRemoveWatermarksImagesPtRaw },
    { slug: 'ai-resume-ats-watermarks-guide', raw: aiResumeAtsWatermarksGuidePtRaw },
    { slug: 'where-to-check-ai-writing', raw: whereToCheckAiWritingPtRaw },
    { slug: 'sora-ai-watermark', raw: soraAiWatermarkPtRaw },
    { slug: 'does-chatgpt-watermark-text', raw: doesChatgptWatermarkTextPtRaw },
    { slug: 'common-ai-words-to-avoid-complete-list', raw: commonAiWordsPtRaw },
    { slug: 'chatgpt-em-dashes-why-ai-uses-them-how-to-remove', raw: chatgptEmDashesPtRaw },
    { slug: 'how-to-spot-ai-generated-text-job-applications', raw: howToSpotAiTextJobApplicationsPtRaw },
    { slug: 'why-all-ai-writing-sounds-the-same', raw: whyAllAiWritingSoundsTheSamePtRaw },
    { slug: 'does-claude-watermark-text', raw: doesClaudeWatermarkTextPtRaw },
  ],
  'ms-MY': [
    { slug: 'invisible-chatgpt-watermarks', raw: invisibleChatgptWatermarksMsRaw },
    { slug: 'ai-watermarks-academic-integrity', raw: aiWatermarksAcademicIntegrityMsRaw },
    { slug: 'chatgpt-text-word-docs-risks', raw: chatgptTextWordDocsRisksMsRaw },
    { slug: 'remove-chatgpt-watermark-word', raw: removeChatGPTWatermarkWordMsRaw },
    { slug: 'ai-watermark-ethics', raw: aiWatermarkEthicsMsRaw },
    { slug: 'invisible-characters-chatgpt', raw: invisibleCharactersChatGPTMsRaw },
    { slug: 'remove-watermarks-word-pages', raw: removeWatermarksWordPagesMsRaw },
    { slug: 'ai-text-watermarks-explained', raw: aiTextWatermarksExplainedMsRaw },
    { slug: 'how-to-check-chatgpt-watermark', raw: howToCheckChatGPTWatermarkMsRaw },
    { slug: 'why-ai-detector-saying-writing-is-ai', raw: whyAiDetectorSayingWritingIsAiMsRaw },
    { slug: 'is-ai-content-bad-for-seo', raw: isAiContentBadForSeoMsRaw },
    { slug: 'can-recruiters-tell-if-you-used-chatgpt', raw: canRecruitersDetectChatgptMsRaw },
    { slug: 'how-to-remove-gemini-image-watermarks', raw: howToRemoveGeminiImageWatermarksMsRaw },
    { slug: 'best-tools-remove-watermarks-images', raw: bestToolsRemoveWatermarksImagesMsRaw },
    { slug: 'ai-resume-ats-watermarks-guide', raw: aiResumeAtsWatermarksGuideMsRaw },
    { slug: 'where-to-check-ai-writing', raw: whereToCheckAiWritingMsRaw },
    { slug: 'sora-ai-watermark', raw: soraAiWatermarkMsRaw },
    { slug: 'does-chatgpt-watermark-text', raw: doesChatgptWatermarkTextMsRaw },
    { slug: 'common-ai-words-to-avoid-complete-list', raw: commonAiWordsMsRaw },
    { slug: 'chatgpt-em-dashes-why-ai-uses-them-how-to-remove', raw: chatgptEmDashesMsRaw },
    { slug: 'how-to-spot-ai-generated-text-job-applications', raw: howToSpotAiTextJobApplicationsMsRaw },
    { slug: 'why-all-ai-writing-sounds-the-same', raw: whyAllAiWritingSoundsTheSameMsRaw },
    { slug: 'does-claude-watermark-text', raw: doesClaudeWatermarkTextMsRaw },
  ],
  es: [
    { slug: 'invisible-chatgpt-watermarks', raw: invisibleChatgptWatermarksEsRaw },
    { slug: 'ai-watermarks-academic-integrity', raw: aiWatermarksAcademicIntegrityEsRaw },
    { slug: 'chatgpt-text-word-docs-risks', raw: chatgptTextWordDocsRisksEsRaw },
    { slug: 'remove-chatgpt-watermark-word', raw: removeChatGPTWatermarkWordEsRaw },
    { slug: 'ai-watermark-ethics', raw: aiWatermarkEthicsEsRaw },
    { slug: 'invisible-characters-chatgpt', raw: invisibleCharactersChatGPTEsRaw },
    { slug: 'remove-watermarks-word-pages', raw: removeWatermarksWordPagesEsRaw },
    { slug: 'ai-text-watermarks-explained', raw: aiTextWatermarksExplainedEsRaw },
    { slug: 'how-to-check-chatgpt-watermark', raw: howToCheckChatGPTWatermarkEsRaw },
    { slug: 'why-ai-detector-saying-writing-is-ai', raw: whyAiDetectorSayingWritingIsAiEsRaw },
    { slug: 'is-ai-content-bad-for-seo', raw: isAiContentBadForSeoEsRaw },
    { slug: 'can-recruiters-tell-if-you-used-chatgpt', raw: canRecruitersDetectChatgptEsRaw },
    { slug: 'how-to-remove-gemini-image-watermarks', raw: howToRemoveGeminiImageWatermarksEsRaw },
    { slug: 'best-tools-remove-watermarks-images', raw: bestToolsRemoveWatermarksImagesEsRaw },
    { slug: 'ai-resume-ats-watermarks-guide', raw: aiResumeAtsWatermarksGuideEsRaw },
    { slug: 'where-to-check-ai-writing', raw: whereToCheckAiWritingEsRaw },
    { slug: 'sora-ai-watermark', raw: soraAiWatermarkEsRaw },
    { slug: 'does-chatgpt-watermark-text', raw: doesChatgptWatermarkTextEsRaw },
    { slug: 'common-ai-words-to-avoid-complete-list', raw: commonAiWordsEsRaw },
    { slug: 'chatgpt-em-dashes-why-ai-uses-them-how-to-remove', raw: chatgptEmDashesEsRaw },
    { slug: 'how-to-spot-ai-generated-text-job-applications', raw: howToSpotAiTextJobApplicationsEsRaw },
    { slug: 'why-all-ai-writing-sounds-the-same', raw: whyAllAiWritingSoundsTheSameEsRaw },
    { slug: 'does-claude-watermark-text', raw: doesClaudeWatermarkTextEsRaw },
  ],
  fr: [
    { slug: 'invisible-chatgpt-watermarks', raw: invisibleChatgptWatermarksFrRaw },
    { slug: 'ai-watermarks-academic-integrity', raw: aiWatermarksAcademicIntegrityFrRaw },
    { slug: 'chatgpt-text-word-docs-risks', raw: chatgptTextWordDocsRisksFrRaw },
    { slug: 'remove-chatgpt-watermark-word', raw: removeChatGPTWatermarkWordFrRaw },
    { slug: 'ai-watermark-ethics', raw: aiWatermarkEthicsFrRaw },
    { slug: 'invisible-characters-chatgpt', raw: invisibleCharactersChatGPTFrRaw },
    { slug: 'remove-watermarks-word-pages', raw: removeWatermarksWordPagesFrRaw },
    { slug: 'ai-text-watermarks-explained', raw: aiTextWatermarksExplainedFrRaw },
    { slug: 'how-to-check-chatgpt-watermark', raw: howToCheckChatGPTWatermarkFrRaw },
    { slug: 'why-ai-detector-saying-writing-is-ai', raw: whyAiDetectorSayingWritingIsAiFrRaw },
    { slug: 'is-ai-content-bad-for-seo', raw: isAiContentBadForSeoFrRaw },
    { slug: 'can-turnitin-detect-chatgpt', raw: canTurnitinDetectChatgptFrRaw },
    { slug: 'can-recruiters-tell-if-you-used-chatgpt', raw: canRecruitersDetectChatgptFrRaw },
    { slug: 'how-to-remove-gemini-image-watermarks', raw: howToRemoveGeminiImageWatermarksFrRaw },
    { slug: 'best-tools-remove-watermarks-images', raw: bestToolsRemoveWatermarksImagesFrRaw },
    { slug: 'ai-resume-ats-watermarks-guide', raw: aiResumeAtsWatermarksGuideFrRaw },
    { slug: 'where-to-check-ai-writing', raw: whereToCheckAiWritingFrRaw },
    { slug: 'sora-ai-watermark', raw: soraAiWatermarkFrRaw },
    { slug: 'does-chatgpt-watermark-text', raw: doesChatgptWatermarkTextFrRaw },
    { slug: 'common-ai-words-to-avoid-complete-list', raw: commonAiWordsFrRaw },
    { slug: 'chatgpt-em-dashes-why-ai-uses-them-how-to-remove', raw: chatgptEmDashesFrRaw },
    { slug: 'how-to-spot-ai-generated-text-job-applications', raw: howToSpotAiTextJobApplicationsFrRaw },
    { slug: 'why-all-ai-writing-sounds-the-same', raw: whyAllAiWritingSoundsTheSameFrRaw },
    { slug: 'does-claude-watermark-text', raw: doesClaudeWatermarkTextFrRaw },
  ],
  ja: [
    { slug: 'invisible-chatgpt-watermarks', raw: invisibleChatgptWatermarksJaRaw },
    { slug: 'ai-watermarks-academic-integrity', raw: aiWatermarksAcademicIntegrityJaRaw },
    { slug: 'chatgpt-text-word-docs-risks', raw: chatgptTextWordDocsRisksJaRaw },
    { slug: 'remove-chatgpt-watermark-word', raw: removeChatGPTWatermarkWordJaRaw },
    { slug: 'ai-watermark-ethics', raw: aiWatermarkEthicsJaRaw },
    { slug: 'invisible-characters-chatgpt', raw: invisibleCharactersChatGPTJaRaw },
    { slug: 'remove-watermarks-word-pages', raw: removeWatermarksWordPagesJaRaw },
    { slug: 'ai-text-watermarks-explained', raw: aiTextWatermarksExplainedJaRaw },
    { slug: 'how-to-check-chatgpt-watermark', raw: howToCheckChatGPTWatermarkJaRaw },
    { slug: 'why-ai-detector-saying-writing-is-ai', raw: whyAiDetectorSayingWritingIsAiJaRaw },
    { slug: 'is-ai-content-bad-for-seo', raw: isAiContentBadForSeoJaRaw },
    { slug: 'can-turnitin-detect-chatgpt', raw: canTurnitinDetectChatgptJaRaw },
    { slug: 'can-recruiters-tell-if-you-used-chatgpt', raw: canRecruitersDetectChatgptJaRaw },
    { slug: 'how-to-remove-gemini-image-watermarks', raw: howToRemoveGeminiImageWatermarksJaRaw },
    { slug: 'best-tools-remove-watermarks-images', raw: bestToolsRemoveWatermarksImagesJaRaw },
    { slug: 'ai-resume-ats-watermarks-guide', raw: aiResumeAtsWatermarksGuideJaRaw },
    { slug: 'where-to-check-ai-writing', raw: whereToCheckAiWritingJaRaw },
    { slug: 'sora-ai-watermark', raw: soraAiWatermarkJaRaw },
    { slug: 'does-chatgpt-watermark-text', raw: doesChatgptWatermarkTextJaRaw },
    { slug: 'common-ai-words-to-avoid-complete-list', raw: commonAiWordsJaRaw },
    { slug: 'chatgpt-em-dashes-why-ai-uses-them-how-to-remove', raw: chatgptEmDashesJaRaw },
    { slug: 'how-to-spot-ai-generated-text-job-applications', raw: howToSpotAiTextJobApplicationsJaRaw },
    { slug: 'why-all-ai-writing-sounds-the-same', raw: whyAllAiWritingSoundsTheSameJaRaw },
    { slug: 'does-claude-watermark-text', raw: doesClaudeWatermarkTextJaRaw },
  ],
  id: [
    { slug: 'invisible-chatgpt-watermarks', raw: invisibleChatgptWatermarksIdRaw },
    { slug: 'ai-watermarks-academic-integrity', raw: aiWatermarksAcademicIntegrityIdRaw },
    { slug: 'chatgpt-text-word-docs-risks', raw: chatgptTextWordDocsRisksIdRaw },
    { slug: 'remove-chatgpt-watermark-word', raw: removeChatGPTWatermarkWordIdRaw },
    { slug: 'ai-watermark-ethics', raw: aiWatermarkEthicsIdRaw },
    { slug: 'invisible-characters-chatgpt', raw: invisibleCharactersChatGPTIdRaw },
    { slug: 'remove-watermarks-word-pages', raw: removeWatermarksWordPagesIdRaw },
    { slug: 'ai-text-watermarks-explained', raw: aiTextWatermarksExplainedIdRaw },
    { slug: 'how-to-check-chatgpt-watermark', raw: howToCheckChatGPTWatermarkIdRaw },
    { slug: 'why-ai-detector-saying-writing-is-ai', raw: whyAiDetectorSayingWritingIsAiIdRaw },
    { slug: 'is-ai-content-bad-for-seo', raw: isAiContentBadForSeoIdRaw },
    { slug: 'can-turnitin-detect-chatgpt', raw: canTurnitinDetectChatgptIdRaw },
    { slug: 'can-recruiters-tell-if-you-used-chatgpt', raw: canRecruitersDetectChatgptIdRaw },
    { slug: 'how-to-remove-gemini-image-watermarks', raw: howToRemoveGeminiImageWatermarksIdRaw },
    { slug: 'best-tools-remove-watermarks-images', raw: bestToolsRemoveWatermarksImagesIdRaw },
    { slug: 'ai-resume-ats-watermarks-guide', raw: aiResumeAtsWatermarksGuideIdRaw },
    { slug: 'where-to-check-ai-writing', raw: whereToCheckAiWritingIdRaw },
    { slug: 'sora-ai-watermark', raw: soraAiWatermarkIdRaw },
    { slug: 'does-chatgpt-watermark-text', raw: doesChatgptWatermarkTextIdRaw },
    { slug: 'common-ai-words-to-avoid-complete-list', raw: commonAiWordsIdRaw },
    { slug: 'chatgpt-em-dashes-why-ai-uses-them-how-to-remove', raw: chatgptEmDashesIdRaw },
    { slug: 'how-to-spot-ai-generated-text-job-applications', raw: howToSpotAiTextJobApplicationsIdRaw },
    { slug: 'why-all-ai-writing-sounds-the-same', raw: whyAllAiWritingSoundsTheSameIdRaw },
    { slug: 'does-claude-watermark-text', raw: doesClaudeWatermarkTextIdRaw },
  ],
};

export function getAllPosts(locale: string = 'en'): BlogPost[] {
  const postsData = blogPostsData[locale] || blogPostsData.en;

  const posts: BlogPost[] = postsData.map(({ slug, raw }) => {
    const { data, content } = parseFrontmatter(raw);

    return {
      slug,
      title: data.title || '',
      description: data.description || '',
      keywords: data.keywords || [],
      author: data.author || '',
      date: data.date || '',
      coverImage: data.coverImage || '',
      content,
      category: data.category || '',
      tags: data.tags || [],
    };
  });

  // Sort by date, newest first
  return posts.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
}

export function getPostBySlug(slug: string, locale: string = 'en'): BlogPost | undefined {
  const posts = getAllPosts(locale);
  return posts.find(post => post.slug === slug);
}
